import IconBibliography from './IconBibliography.vue'

export { IconBibliography }
